//#region Tilemenu
$(function () {

    //$('.tilemenu-link').mouseenter(function () {
    //    $(this).find('.tilemenu-link-body > svg, .tilemenu-link-id').slideUp(100)
    //})
    //$('.tilemenu-link').mouseleave(function () {
    //    $(this).find('.tilemenu-link-body > svg, .tilemenu-link-id').slideDown(100)
    //})
    $('.tilemenu-link a').click(function () {
        loading.show($(this).parent())
    })

    $('.kdr-tilemenu-expand-all').click(function () {
        tilemenu.expandRows()
    })

    $('.kdr-tilemenu-fold-all').click(function () {
        tilemenu.collapseRows()
    })

    ///search for raports matching user 
    $('.kdr-tilemenu-search-input')
        .change(function () {
            tilemenu.searchItems()
            tilemenu.expandRows()
        })
        .keyup(function () { $('.kdr-tilemenu-search-input').change() })

    $('.kdr-tilemenu-search-erase').click(function () {
        if ($('.kdr-tilemenu-search-input').val().length != '0') {
            $('.kdr-tilemenu-search-input').val(null);

            tilemenu.searchItems()
            //tilemenu.collapseRows()
        }
    })
    $(document).on('shown.bs.collapse', '.modal .tilemenu-row > .collapse', function () {
        tilemenu.scrollView($(this))
    })
})

var tilemenu = {
    colors: [
        "#E69F00", 
        "#009E73", 
        "#0072B2", 
        "#D55E00", 
        "#CC79A7", 
        "#00A9CF", 
        "#F39C12", 
        "#2ECC71", 
        "#8E44AD", 
        "#E74C3C", 
        "#1ABC9C", 
        "#34495E", 
        "#A569BD", 
        "#17A589", 
        "#34346A"
        
    ],
    collapseRows() {
        $('.tilemenu-row .collapse').each(function () {
            $(this).collapse('hide')
            $(this).attr('data-parent', "#tilemenu-collapse")
        })
    },
    expandRows() {
        $('.tilemenu-row .collapse').each(function () {
            $(this).removeAttr('data-parent')
            $(this).collapse('show')
        })
    },
    searchItems() {
        let searchValues = $('.kdr-tilemenu-search-input').val().toLowerCase().split(',')
        $('.tilemenu-link').each(function () {

            let $link = $(this)
            let isInSearchValueP = $link.find(".tilemenu-link-title, .tilemenu-title-number").toArray().some(x => {
                let $item = $(x)
                let text = $item.text().toLowerCase()

                return ((searchValues.length == 1 && textHelper.isNullOrEmpty(searchValues[0]?.trim() ?? '')) || searchValues.some(y => textHelper.isNullOrEmpty(y) ? false : text.includes(y.trim())))
            })

            if (isInSearchValueP) {
                $link.removeClass('hide')
            } else {
                $link.addClass('hide')
            }
        })

        tilemenu.toggleRows()
    },
    toggleRows() {
        $('.tilemenu-row-body').each(function (i) {
            let allChildrensCount = $(this).find('.tilemenu-link').length
            let hiddenChildrensCount = $(this).find('.tilemenu-link.hide').length

            if (hiddenChildrensCount == allChildrensCount) {
                $(this).closest('.tilemenu-row').addClass('hide')
            } else {
                $(this).closest('.tilemenu-row').removeClass('hide')
            }
        })
    },
    scrollView($element) {
        $element.closest('.modal').animate({ scrollTop: $element.position().top }, 250)
    },
    generateDisplayValues($tilemenu) {
        let $wrapper = $tilemenu.find('.tilemenu-display-values-wrapper')

        if ($wrapper.length == 0) {
            return;
        }

        let expandP = $wrapper.attr('data-expand-p')

        let $groups = $tilemenu.find('.kdr-filters-group')
        let index = 0;
        let tooltipText = ''

        $wrapper.empty()

        for (let i = 0; i < $groups.length; i++) {
            let $inputs = $($groups[i]).find('.kdr-filters-input')
            $($groups[i]).find('.kdr-filter-group-color').css('background-color', tilemenu.colors[i])

            for (let j = 0; j < $inputs.length; j++) {

                let text = $inputs[j].value;
                let $this = $($inputs[j])

                if ($this.hasClass('dropdown-toggle')) {

                    if ($this.hasClass('kdr-frax-dropdown-button')) {
                        text = $this.find('.kdr-frax-dropdown-selected-item').text()
                    } else {
                        if ($this.attr('data-value') == 0) {
                            continue
                        }

                        let trimText = $this.find('.items_selected-text-item, .item_selected-text')
                            .map(function () { return $(this).text().trim(); })
                            .get()
                            .filter(t => t.length > 0);

                        text = trimText.join(', ');
                    }
                }
                else if (text == 'on' /*&& i < 5*/) {
                    if ($inputs[j].checked) {
                        text = $this.closest('.custom-checkbox').find('label').text()
                    }
                    else {
                        continue
                    }
                }

                if (text != null && text != undefined && text != '') {
                    let hideClass = 'tilemenu-display-value-element '
                    if (index >= 5) {
                        hideClass += 'tilemenu-display-value-element-hidden '
                        if (expandP == 'true') {
                            hideClass += ''
                        }
                        else {
                            hideClass += 'hide'
                        }
                    }

                    let $el = $('<div>', { class: hideClass, style: 'background-color:' + tilemenu.colors[i] + '30;color:' + tilemenu.colors[i] + ';font-size:0.8rem;display:flex;align-items:center' })
                        .append($('<span data-toggle="tooltip" data-html="true" data-placement="top" title="' + $($inputs[j]).closest('td').find('.form-group-title-label, .kdr-dropdown-w-search-title-label').text() + '">').text(text));

                    $wrapper.append($el);
                    index++;
                }
                if (text != null && text != undefined && text != '' && index > 5) {
                    let title = $($inputs[j]).closest('td').find('.form-group-title-label, .kdr-dropdown-w-search-title-label').text().trim()
                    title += (title.length > 0 ? ': ' : '')
                    tooltipText += title + text + '<br>';
                }

            }

        }

        if (index > 5) {
            var $expand = $('<div>', { class: 'tilemenu-display-value-element tilemenu-click-expand-btn ', style: 'background-color:' + tilemenu.colors[tilemenu.colors.length - 1] + '30;color:' + tilemenu.colors[tilemenu.colors.length - 1] + ';cursor:pointer;font-size:0.8rem;display:flex;align-items:center' })
                .append($('<span data-toggle="tooltip" data-html="true" data-placement="top" title="' + tooltipText + '">').text('+' + (index - 5)));

            var $collapse = $('<div>', { class: 'tilemenu-display-value-element tilemenu-click-expand-btn', style: 'background-color:' + tilemenu.colors[tilemenu.colors.length - 1] + '30;color:' + tilemenu.colors[tilemenu.colors.length - 1] + ';cursor:pointer;font-size:0.8rem;display:flex;align-items:center' })
                .append($('<span data-toggle="tooltip" data-html="true" data-placement="top" title="' + __l.Collapse + '">').html('<i class="fas fa-chevron-double-left"></i>'));

            if (expandP == 'true') {
                $expand.toggleClass('hide')
            } else {
                $collapse.toggleClass('hide')
            }

            $wrapper.append($expand);
            $wrapper.append($collapse);
            $wrapper.find('[data-toggle="tooltip"]').tooltip()
        }
    },
    hideTooltip(tileMenuA) {
        //deb(tileMenuA)
        let tId = $(tileMenuA).attr('aria-describedby')
        //deb(tID)
        $('#' + tId).tooltip('dispose')
    },
    toggleTilemenuView() {
        //$('.kdr-filters').toggleClass('kdr-filters-modern')
        $('.tilemenu-row-body-parent').toggleClass('tilemenu-modern-row')
        $('.tilemenu-display-values-wrapper').toggleClass('hide')
        $('.tilemenu-row-header-btn-collapse').toggleClass('hide')
        $('.tilemenu-item-header_icon').toggleClass('hide')
        $('.tilemenu').toggleClass('tilemenu-modern')

        if ($('.tilemenu-row-header').attr('data-toggle')) {
            $('.tilemenu-row-header').removeAttr('data-toggle')
        } else {
            $('.tilemenu-row-header').attr('data-toggle', 'collapse')
        }
    }
}

$(document).on('click', '.tilemenu-click-expand-btn', function () {
    $('.tilemenu-display-value-element-hidden').toggleClass('hide')
    $('.tilemenu-click-expand-btn').toggleClass('hide')

    let $wrapper = $('.tilemenu-display-values-wrapper')

    let x = $wrapper.attr('data-expand-p')

    if (x == 'false') {
        $wrapper.attr('data-expand-p', true)
    }
    else {
        $wrapper.attr('data-expand-p', false)
    }
})
//#endregion Tilemenu